import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { INFO_PANEL_DESCRIPTION } from "~/constants/testIDs";
export const AssetTitleAndDescriptionContainer = /*#__PURE__*/ memo((param)=>{
    let { title, description } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full bg-grey-2 px-6 py-4",
        children: [
            title,
            /*#__PURE__*/ _jsx("div", {
                "data-testid": INFO_PANEL_DESCRIPTION,
                className: "mt-1 flex w-full shrink-0",
                children: description
            })
        ]
    });
});
AssetTitleAndDescriptionContainer.displayName = "AssetTitleAndDescriptionContainer";
